<span [class]="classes()" [title]="title()">{{ letter() }}</span>
